import Vue from "vue";

const { assign } = Object;

export default {
    namespaced: true,

    state: {
        displayCitation: false,
        displayMetadata: false,
        displayPersonAreas: false,
        displayProjectAreas: false,
        displayWatchlist: false,
        eventBus: new Vue(),
        opacity: 75,
        watchlist: {},
    },

    getters: {
        facsimile(state, getters, rootState, rootGetters) {
            const { id } = rootGetters["toc/current"] || {};
            return id ? `/iiif/3/${id}/info.json` : null;
        },
    },

    mutations: {
        addPageToWatchlist(state, page) {
            let pageToAdd = page;
            // we need to remove parent references because vuex-persistedstate uses JSON.stringify, which cannot handle circular references
            if (pageToAdd.parent) {
                pageToAdd = assign({}, pageToAdd);
                delete pageToAdd.parent;
            }
            const i = Object.keys(state.watchlist).length;
            Vue.set(
                state.watchlist,
                pageToAdd.id,
                assign({ seq: i + 1 }, pageToAdd)
            );
        },

        changeOpacity(state, { opacity }) {
            assign(state, { opacity });
        },

        clearWatchList(state) {
            assign(state, { watchlist: {} });
        },

        moveWatchlistItemDown(state, page) {
            const { seq } = state.watchlist[page.id];
            const keys = Object.keys(state.watchlist);
            if (seq === keys.length) {
                return;
            }
            const successor = keys.filter((k) => {
                return state.watchlist[k].seq === seq + 1;
            });
            if (successor.length === 1) {
                state.watchlist[successor].seq = seq;
                state.watchlist[page.id].seq = seq + 1;
            } else {
                console.error(
                    "Expected to find exactly one successor, but found " +
                        successor.length
                );
            }
        },

        moveWatchlistItemUp(state, page) {
            const { seq } = state.watchlist[page.id];
            if (seq === 1) {
                return;
            }
            const keys = Object.keys(state.watchlist);
            const predecessor = keys.filter((k) => {
                return state.watchlist[k].seq === seq - 1;
            });
            if (predecessor.length === 1) {
                const { watchlist } = state;
                watchlist[predecessor].seq = seq;
                watchlist[page.id].seq = seq - 1;
            } else {
                console.error(
                    "Expected to find exactly one predecessor, but found " +
                        predecessor.length
                );
            }
        },

        removePageFromWatchlist(state, page) {
            const { seq } = state.watchlist[page.id];
            Vue.delete(state.watchlist, page.id);
            Object.keys(state.watchlist)
                .filter((k) => {
                    return state.watchlist[k].seq > seq;
                })
                .forEach((k) => {
                    const { watchlist } = state;
                    watchlist[k].seq = watchlist[k].seq - 1;
                });
        },

        setWatchlist(state, list) {
            assign(state, { watchlist: list });
        },

        toggleCitationDisplay(state) {
            assign(
                state,
                { displayCitation: !state.displayCitation },
                resetDisplayTogglesExcept("displayCitation")
            );
        },

        toggleMetadataSnippet(state) {
            assign(
                state,
                { displayMetadata: !state.displayMetadata },
                resetDisplayTogglesExcept("displayMetadata")
            );
        },

        togglePersonAreasDisplay(state) {
            assign(
                state,
                { displayPersonAreas: !state.displayPersonAreas },
                resetDisplayTogglesExcept("displayPersonAreas")
            );
        },

        toggleProjectAreasDisplay(state) {
            assign(
                state,
                { displayProjectAreas: !state.displayProjectAreas },
                resetDisplayTogglesExcept("displayProjectAreas")
            );
        },

        toggleWatchlistDisplay(state) {
            assign(
                state,
                { displayWatchlist: !state.displayWatchlist },
                resetDisplayTogglesExcept("displayWatchlist")
            );
        },
    },
};

function resetDisplayTogglesExcept(exception) {
    let toggles = {
        displayCitation: false,
        displayMetadata: false,
        displayPersonAreas: false,
        displayProjectAreas: false,
        displayWatchlist: false,
    };
    delete toggles[exception];
    return toggles;
}
